// extracted by mini-css-extract-plugin
module.exports = {"DemoContainer":"Demo_DemoContainer__GxF_y","DemoFrame":"Demo_DemoFrame__2TL0z"};